var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStudyNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 128,
    height: 128,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 7.5c0-1 .8-1.8 1.8-2 2.4-.6 5.1-.5 7.2.9v11.8c-2.1-1.4-4.8-1.6-7.2-1-1 .3-1.8-1-1.8-2V7.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 7.5c0-1-.8-1.8-1.8-2-2.4-.6-5.1-.5-7.2.9v11.8c2.1-1.4 4.8-1.6 7.2-1 1 .3 1.8-1 1.8-2V7.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6.2v11.6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudyNote);
export default __webpack_public_path__ + "static/media/study_note.7cec99816754c30080b074233e033d3f.svg";
export { ForwardRef as ReactComponent };